import {z} from '@hono/zod-openapi';

/**
 * A non-negative whole number as the database returns it: a JS number or a digit string.
 * Deliberately not `z.coerce.number()`, for the same reason as `amount` - coercion turns
 * `null` and `''` into `0`, which reports a definite count where there is none.
 */
export const count = z
  .union([z.number(), z.string().regex(/^\d+$/)])
  .transform(Number)
  .pipe(z.number().int().nonnegative());
